// Keeps <head> in step with the current route.
//
// The build writes a real HTML file per route with these tags already correct
// (scripts/prerender-routes.mjs), so crawlers see them without running any JS.
// This module handles the same tags for in-page navigation afterwards.

import { LANGS, DEFAULT_LANG, urlFor } from './routes';
import { META, NAV } from './content';

export function titleFor(lang, page) {
  const { siteTitle } = META[lang];
  return page === 'home' ? siteTitle : `${NAV[lang][page]} – ${siteTitle}`;
}

function upsert(selector, build) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = build();
    document.head.appendChild(el);
  }
  return el;
}

export function syncHead(lang, page) {
  document.documentElement.lang = lang;
  document.title = titleFor(lang, page);

  upsert('meta[name="description"]', () => {
    const el = document.createElement('meta');
    el.setAttribute('name', 'description');
    return el;
  }).setAttribute('content', META[lang].description);

  upsert('link[rel="canonical"]', () => {
    const el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    return el;
  }).setAttribute('href', urlFor(lang, page));

  // Rebuild the alternate set wholesale -- the targets all change with `page`.
  document.head
    .querySelectorAll('link[rel="alternate"][hreflang]')
    .forEach((el) => el.remove());

  const alternates = [...LANGS.map((l) => [l, l]), ['x-default', DEFAULT_LANG]];
  for (const [hreflang, lang_] of alternates) {
    const el = document.createElement('link');
    el.setAttribute('rel', 'alternate');
    el.setAttribute('hreflang', hreflang);
    el.setAttribute('href', urlFor(lang_, page));
    document.head.appendChild(el);
  }
}
